import palette from '../palette';

const MuiDialogTitle = {
  styleOverrides: {
    root: {
      color: palette.text.primary,
    },
  },
};

export default MuiDialogTitle;
